var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "subscription-info-error-view" } },
    [
      _c(
        "div",
        { staticClass: "flex flex-grow-1 alert alert-danger w-100 mb-2" },
        [
          _c("i", { staticClass: "far fa-exclamation-circle mr-2" }),
          _vm._v(" " + _vm._s(_vm.$t("xSomethingWentWrong")) + " ")
        ]
      ),
      _c("div", [_c("p", [_vm._v(_vm._s(_vm.$t("xUnableToLoadPlanInfo")))])]),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c(
            "b-col",
            { staticClass: "flex flex-grow-1", attrs: { cols: "6" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "w-100 footer-button",
                  attrs: {
                    variant: "secondary",
                    "data-test-hook":
                      "subscription-error-contact-support-button"
                  },
                  on: {
                    click: function($event) {
                      return _vm.navToSupportPage()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("xContactSupportUpgrade")) + " ")]
              )
            ],
            1
          ),
          _c(
            "b-col",
            { staticClass: "flex flex-grow-1", attrs: { cols: "6" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "w-100 footer-button",
                  attrs: {
                    variant: "warning",
                    "data-test-hook": "subscription-error-try-again-button"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("retry")
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("xTryAgain")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }